import Icon from '__core/modules/atoms/Icons/Icon';
import InputText from '__core/modules/atoms/InputText';
import DialogDefault from '__core/modules/components/dialogs/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import useDialogDelete from './useDialogDelete';

function DialogDelete({
  buttonTextCancel,
  buttonTextSucess = '',
  hasConfirm,
  icon = 'icon-warning-circle',
  onClose,
  onSuccess,
  open,
  size = 's',
  subtitle = '',
  subtitle2,
  textStringLangConfirmMessage,
  textStringLangConfirmText,
  title = '',
}) {
  const { textSubtitle, textTitle, value, onChangeInput, t } = useDialogDelete({ title, subtitle, open });

  return (
    <DialogDefault
      buttonTextCancel={buttonTextCancel || t('Cancel')}
      buttonTextSucess={buttonTextSucess || t('Delete')}
      className="dialog-delete"
      disabledSuccess={hasConfirm ? value !== t(textStringLangConfirmText) : false}
      hideHeader
      onCancel={onClose}
      onClose={onClose}
      onSuccess={onSuccess}
      open={open}
      size={size}
    >
      <div className="d-flex align-items-center mb-3">
        <Icon type={icon} fontSize="large" color="error" />
        <span className="dialog-exit-page__title ml-3">{textTitle}</span>
      </div>

      {typeof textSubtitle === 'string' ? (
        <p className="dialog-exit-page__description">{textSubtitle}</p>
      ) : (
        <div className="dialog-exit-page__description">{textSubtitle}</div>
      )}

      {subtitle2 && <p className="dialog-exit-page__description">{subtitle2}</p>}

      {hasConfirm && (
        <>
          <p className="dialog-exit-page__description">
            <Trans i18nKey={textStringLangConfirmMessage} values={{ name: t(textStringLangConfirmText) }} components={{ strong: <strong /> }} />
          </p>

          <div className="mt-4 mb-3">
            <InputText onChange={onChangeInput} placeholder={t(textStringLangConfirmText)} value={value} />
          </div>
        </>
      )}
    </DialogDefault>
  );
}

DialogDelete.propTypes = {
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  hasConfirm: PropTypes.bool,
  icon: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  size: PropTypes.string,
  subtitle: PropTypes.node,
  textStringLangConfirmMessage: PropTypes.string, // dialogs:message_confirm_delete
  textStringLangConfirmText: PropTypes.string, // dialogs:message_confirm_delete_text
  title: PropTypes.node,
};

export default DialogDelete;
